import { CounterInput } from './counter-input';
import type { CounterInputProps } from './use-counter-input';

import { FormControl, FormItem, FormMessage } from '../../form';

export const FormCounter = ({
  formItemClassName,
  hideMsg,
  ...props
}: CounterInputProps & { formItemClassName?: string; hideMsg?: boolean }) => (
  <FormItem className={formItemClassName}>
    <FormControl>
      <CounterInput {...props} />
    </FormControl>
    {!hideMsg && <FormMessage />}
  </FormItem>
);
